export default __webpack_public_path__ + "static/media/8.08d7fd61.wav";